import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";

import RolesTableComponent from "../../components/panel/roles/RolesTable";
import CreateRoleModal from "../../components/panel/roles/CreateRoleModal";
import { RoleSchema } from "../../services/Schemas/Role";
import { AccessEnums } from "../../constants/accessEnum";
import { useCanAccess } from "../../hooks/canAccess";

export default function RolesPage() {
  const [walletReload, setWalletReload] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [roleInfo, setRoleInfo] = useState<RoleSchema | undefined>(undefined);
  const { can } = useCanAccess();

  const onClose = (payload: boolean) => {
    setOpenModal(payload);
    setRoleInfo(undefined);
  };

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                نقش ها
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                لیست نقش ها
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              <Button
                variant="contained"
                disabled={!can(AccessEnums.AdminAclRolesCreate)}
                onClick={() => setOpenModal(true)}
              >
                ایجاد نقش
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <RolesTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
          setOpenModal={setOpenModal}
          setRoleInfo={setRoleInfo}
        />
        <CreateRoleModal
          onClose={onClose}
          handleReload={() => setWalletReload(!walletReload)}
          open={openModal}
          roleInfo={roleInfo}
        />
      </Stack>
    </>
  );
}
